<template>
  <div class="businessData">
    <div class="headerTitle">
      <div class="headerDescribe">
        <img class="businessImg" src='~common/image/businessData.png'>
        <span class="titleSpan">营业数据概况</span>
        <img class="questionImg" src='~common/image/question.png' @click="textVisibleFn">
      </div>
      <data-header @select-resturantId ='changeResturantId' ></data-header>
    </div>
    <mt-popup v-model="popupTextVisible" class="popupTextArea" popup-transition="popup-fade">
      <div v-for="(textItem,index) in textSlots" class="textItem" :key="index">
        <span v-text="textItem.textWord"></span>
      </div>
    </mt-popup>
    
    <div class="businessContent">
      <div class="businessBody">
        <date-select @select-date ='getSelectDate' :dataTimeMenu='dayMenu'></date-select>
        <div class="amountDiv">
          <div class="amountMoneyDiv">
            <div class="amountMoney">{{this.businessData.paidMoney}}</div>
            <div class="betweenWidth"></div>
            <div class="amountText">实收金额（元）</div>
          </div>
          <div class="amountOrderDiv">
            <div class="amountOrder">{{this.businessData.paidNumber}}</div>
            <div class="betweenWidth"></div>
            <div class="amountText">已支付订单数（单）</div>
          </div>
        </div>
        <div class="hengLine"></div>
        <div class="favourPeoperDiv">
          <div class="favourDiv">
            <div class="favourMoneyText">优惠合计（元）</div>
             <div class="betweenWidth2"></div>
            <div class="favourMoney">{{this.businessData.tatolSpecialMoney}}</div>                    
          </div>
          <div class="shuLine"></div>
          <div class="peopleDiv">
            <div class="peopleText">客流量（人）</div>
            <div class="betweenWidth2"></div>
            <div class="peopleCount">{{this.businessData.gusetsCount}}</div>            
          </div>
          <div class="shuLine"></div>
          <div class="perDiv">
            <div class="perText">人均消费（元）</div>
            <div class="betweenWidth2"></div>
            <div class="perMoney">{{this.businessData.avgMoney}}</div>                     
          </div>
        </div>
        <div class="ifShowDiv">
          <div class="hengLine"></div>
          <div class="totalOrderMoneyDiv">
            <div class="totalOrderMoney">
              <div class="totalMoneyText">订单总金额（元）</div>
              <div class="betweenWidth2"></div>
              <div class="totalMoney">{{this.businessData.totalMoney}}</div>            
            </div>
            <div class="noPayOrderMoney">
              <div class="noPayOrderText">未支付订单总金额（元）</div>
              <div class="betweenWidth2"></div>
              <div class="noPayMoney">{{this.businessData.unpaidMoney}}</div>                     
            </div>
          </div>
          <div class="totalOrderDiv">
            <div class="totalOrder">
              <div class="totalOrderText">总订单数（单）</div>
              <div class="betweenWidth2"></div>
              <div class="totalOrderCount">{{this.businessData.totalNumber}}</div>            
            </div>
            <div class="noPayTotalOrder">
              <div class="noPayOrderText">未支付订单数（单）</div>
              <div class="betweenWidth2"></div>
              <div class="noPayOrderCount">{{this.businessData.unpaidNumber}}</div>                     
            </div>
          </div>
        </div>
        <!-- <div class="stretchDiv" @click="showStretchDiv">
          <span class="stretchSpan">{{this.showText}}</span>
          <img class="stretchImg" v-show="showUpImg" src='~common/image/down.png'>
          <img class="stretchImg" v-show="!showUpImg"src='~common/image/up.png'>
        </div> -->
      </div>     
    </div>
    <div class="payOrderList">
      <div class="payDataDiv" @click="payMentDataFn">
        <div class="imgDiv">
          <img class="payDataImg" src="~common/image/payPersent.png">
          <span class="payDataSpan">支付方式占比数据</span>
        </div>
        <div>
          <img class="turnRight" src="~common/image/turnRight.png">
        </div>          
      </div>
      <div class="orderDataDiv" @click="orderListDataFn">
        <div class="imgDiv">
          <img class="orderDataImg" src="~common/image/havePay.png">
          <span class="orderDataSpan">已收款订单列表</span>
        </div>
        <div>
          <img class="turnRight" src="~common/image/turnRight.png">
        </div>        
      </div>
    </div>
    <div class="updateTime">
      <span>（数据更新时间：</span><span>{{this.businessData.createAt | capitalize}}）</span>
    </div>   
    <div class="infoTip">
      <span>此数据由 旗鱼点餐-智能点餐系统领导者 提供</span>
    </div>
  </div>
</template>
<script>
import DataHeader from 'components/dataHeader'
import DateSelect from 'components/dateSelect'
import { mapActions } from 'vuex'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      businessData: {},
      restaurantId: 0,
      mydata: '',
      showUpImg: true,
      showText: '展开',
      isShow: false,
      ifShowMask: false,
      ifShowDate: false,
      pickerValue: new Date(),
      startDate: '',
      endDate: '',
      tType:0,
      startDateFormat: new Date(),
      endDateFormat: new Date(),
      startOrEnd: '',
      dayMenu: [{ 'name': '今日收入' }, { 'name': '昨日收入' }, { 'name': '自定义' }],
      dayFlag: 0,
      popupTextVisible: false,
      textSlots: [
        {
          textWord: '数据相关说明'
        },
        {
          textWord: '1、实收金额：指门店实际收入的金额，包含订单收银、自由收银、定额收银实收金额。'
        },
        {
          textWord: '2、已支付订单数：指门店已生成订单中，已支付订单的笔数。'
        },
        {
          textWord: '3、优惠合计=抹零+折扣金额+减满金额+单品券优惠金额+会员优惠金额。'
        },
        {
          textWord: '4、客流量：根据点餐时选择的用餐人数来统计。（客流量仅根据已支付订单的数据统计，如订单没有用餐人数数据，默认为1人。）'
        },
        {
          textWord: '5、人均消费=实收金额/客流量'
        },
        {
          textWord: '6、订单总金额：指门店生成的所有订单的总额。（实收金额+未支付订单金额=订单总金额）'
        },
        {
          textWord: '7、总订单数：指门店生成的所有订单的总笔数。'
        },
        {
          textWord: '8、未支付订单金额：指门店生成的订单中，未支付订单的总金额。'
        },
        {
          textWord: '9、未支付订单数：指门店生成的订单中，未支付订单的总笔数。'
        }
      ]
    }
  },
  components: {
    // DatetimePicker,
    DataHeader,
    DateSelect
  },
  mounted() {
    this.todayOrYesday()
  },
  computed: {
    getResturantId: function() {
      return this.$store.state.resturantId
    }
  },
  methods: {
    ...mapActions([
      'updataStatisticalDate' // 映射 this.increment() 为 this.$store.dispatch('increment')
    ]),
    todayOrYesday() {
      if (this.common.localGet('dayFlag') === 1) {  // 昨日数据
        this.startDate = this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)
        this.endDate = this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)
				this.tType = 3
      } else if (this.common.localGet('dayFlag') === 0) { // 今日数据
        this.startDate = this.common.formatDate(new Date())
        this.endDate = this.common.formatDate(new Date())
				this.tType = 0
      }
      this.getBusinessData(this.startDate, this.endDate,this.tType)
    },
    textVisibleFn() {
      this.popupTextVisible = true
    },
    payMentDataFn() {
      this.$router.push({ path: '/payMentData' }) // 跳转到支付数据页面
    },
    orderListDataFn() {
      this.$router.push({ path: '/orderList' }) // 跳转到订单列表页面
    },
    getBusinessData(start, end,tType) {
      const _this = this
      this.$http.get(this.common.url_order + '/sumYesterdayBis', {
        params: {
          restaurantIds: _this.getResturantId,
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          openId: _this.common.localGet('openId'),
          startTime: start,
          endTime: end,
          tType: tType
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          console.log(JSON.stringify(response.data))
          if (response.data.data === null) {
            console.log('此日数据为空')
          } else {
            _this.businessData = response.data.data
            _this.mydata = response.data.data.createAt
            _this.businessData.paidMoney = _this.businessData.paidMoney.toFixed(2)  // 实收金额 保留两位小数
            _this.businessData.paidNumber = _this.businessData.paidNumber  // 已支付订单数
            _this.businessData.tatolSpecialMoney = _this.businessData.tatolSpecialMoney.toFixed(2)  // 优惠金额 保留两位小数
            _this.businessData.gusetsCount = _this.businessData.gusetsCount  // 客流量
            _this.businessData.avgMoney = _this.businessData.avgMoney.toFixed(2)// 人均消费
            _this.businessData.totalMoney = _this.businessData.totalMoney.toFixed(2)  // 订单总金额 保留两位小数
            _this.businessData.unpaidMoney = _this.businessData.unpaidMoney.toFixed(2) // 未支付订单总金额
            _this.businessData.totalNumber = _this.businessData.totalNumber  // 总订单数
            _this.businessData.unpaidNumber = _this.businessData.unpaidNumber  // 未支付订单数
          }
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    },
    getSelectDate(date) {
      this.startDate = date[0]
      this.endDate = date[1]
			this.tType = 4
      this.getBusinessData(this.startDate, this.endDate,this.tType)
    },
    changeResturantId() {
      this.getBusinessData(this.startDate, this.endDate,this.tType)
    }
  }
}
</script>
<style >
@import '../common/css/picker.css';
  .businessData{
    width: 100%;
    background-color: #f1f2f3;
    padding-top: 1rem;
    margin-bottom: 1.58rem;
  }
  .headerTitle{
    position:fixed;
    top:0;
    left:0;
    z-index: 100;
    width:100%;
    height: 0.9rem;
    line-height: 0.9rem;
    display:flex;
    display: -webkit-flex; 
    justify-content: space-between;
    align-items:center;
    background-color: #ffffff; 
    -moz-box-shadow:0px 6px 0px rgba(171,175,177,.40); -webkit-box-shadow:0px 6px 0px rgba(171,175,177,.40); box-shadow:0px 6px 0px rgba(171,175,177,.40);
  }
  .headerDescribe{
    display:flex;
    display: -webkit-flex; 
    align-items:center;
    margin-left: 0.2rem;
  }
  .titleSpan{
    font-size: 0.28rem;
    font-weight: 600;
    color:#000000;
  }
  .businessImg{
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.1rem;
  }
  .questionImg{
    width: 0.24rem;
    height: 0.24rem;
    margin-left: 0.08rem;
  }
  .popupTextArea{
    width: 6.4rem;
    height: 8.4rem;
    background-color: #ffffff;
    padding: 0.28rem 0.26rem;
    border-radius: 8px;
  }
  .textItem:first-child{
    text-align: center;
    margin-bottom:0.4rem;
    font-size: 0.28rem;
    font-weight: bold;
  }
  .textItem:not(:first-child){
    text-align: left;
    font-size: 0.26rem;
    color:#555555;
    line-height: 0.43rem;
  }
  .businessContent{
    width: 100%;
    /* height: 4.6rem; */
    height: auto;
    padding: 0.14rem 0.1rem 0.16rem 0.1rem;
    background-color: #ffcece;
  }
  .businessBody{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 10px;
    background:-webkit-gradient(linear, 0 0, 0 bottom, from(#fc706b), to(#ff0036));
  }
  .amountDiv{
    width: 100%;
    height: 1.7rem;
    display: flex;
    align-items:center;
    justify-content: center;
  }
  .favourPeoperDiv{
    width: 100%;
    height: 1.4rem;
    display: flex;
    align-items:center;
    justify-content: space-around;
  }
  .amountMoneyDiv,.amountOrderDiv{
    width: 50%;
    height: 100%;
    display: flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
  }
  .favourDiv,.peopleDiv,.perDiv{
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
  }
  .shuLine{
    height: 58%;
    border-left: 1px solid #cccccc;
  }
  .hengLine{
    width: 90%;
    border-top: 1px solid #FE7779;
  }
  .amountMoney,.amountOrder{
    font-size: 0.76rem;
    color: #ffffff;
    font-weight: 600;
  } 
  .favourMoney,.peopleCount,.perMoney,.totalMoney,.noPayMoney,.totalOrderCount,.noPayOrderCount{
    font-size: 0.4rem;
    color: #ffffff;
    font-weight: 600;
  } 
  .amountText{
    font-size: 0.3rem;
    color: #ffffff;
  }
  .favourMoneyText,.peopleText,.perText,.totalMoneyText,.noPayOrderText,.totalOrderText{
    font-size: 0.28rem;
    color: #FFA6A7;
  }
  .betweenWidth{
    width: 100%;
    height: 0.26rem;
  }
  .betweenWidth2{
    width: 100%;
    height: 0.18rem;
  }
  .totalOrderMoneyDiv,.totalOrderDiv{
    width: 100%;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .totalOrderMoney,.noPayOrderMoney,.totalOrder,.noPayTotalOrder{
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .ifShowDiv{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .stretchDiv{
    width: 100%;
    height: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .stretchSpan{
    margin-right: 0.08rem;
    font-size: 0.24rem;
    color: #FFC3CA;
  }
  .stretchImg{
    width: 0.2rem;
    height: 0.1rem;
  }
  .payOrderList{
    margin-top: 0.1rem;
  }
  .imgDiv{
    display: flex;
    align-items: center;
  }
  .payDataDiv,.orderDataDiv{
    width: 100%;
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.3rem 0 0.34rem;
    background-color: #ffffff;
  }
  .infoTip{
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
    position: fixed;
    bottom: 0.98rem;
    text-align: center;
    font-size: 0.2rem;
    color: #999999;
    background-color: #f1f2f3;
  }
  .payDataDiv{
    border-bottom: 1px solid #f1f2f3;
  }
  .payDataImg,.orderDataImg{
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.15rem;
  }
  .payDataSpan,.orderDataSpan{
    font-size: 0.28rem;
    color: #000000;
    font-weight: bold;
  }
  .turnRight{
    width: 0.18rem;
    height: 0.26rem;;
  }
  .updateTime{
    width: 100%;
    height: 0.7rem;
    display: flex;
    margin-top: 0.1rem;
    align-items: center;
    justify-content: center;
    background-color: #f1f2f3;
  }
  .updateTime span{
    font-size: 0.24rem;
    color:#000000;
  } 
</style>



// WEBPACK FOOTER //
// src/components/businessData.vue